import { render, staticRenderFns } from "./WorkFlowDialog.vue?vue&type=template&id=51f0a31f&scoped=true&"
import script from "./WorkFlowDialog.vue?vue&type=script&lang=js&"
export * from "./WorkFlowDialog.vue?vue&type=script&lang=js&"
import style0 from "./WorkFlowDialog.vue?vue&type=style&index=0&id=51f0a31f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f0a31f",
  null
  
)

export default component.exports